import React, { useEffect } from "react";

import Container from "@material-ui/core/Container";
import ApplicationHeader from "../application/ApplicationHeader";
import ApplicationPanel from "../application/ApplicationPanel";
import { Route, useHistory, useRouteMatch } from "react-router-dom";
import withAuthorization from "../auth/withAuthorization";
import HomeDashboardView from "./HomeDashboardView";
import { notBlank } from "../util/ext";
import { setCurrentOrganization } from "../auth/authActions";
import { find } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { hasAnyRole, hasRole, hasAdminRole } from "../auth/authUtils";
import { creatorRoles } from "../auth/authUtils";

const nonAdminCreatorRoles = [
  "ROLE_CREATOR_MANAGER",
  "ROLE_CONTENT_MANAGER",
  "ROLE_CREATOR_USER",
];

const notManager = auth =>
  notBlank(auth.user) &&
  !hasAnyRole(auth.currentOrganization, [
    "ROLE_CREATOR_MANAGER",
    "ROLE_CONTENT_MANAGER",
  ]);

const notCreatorUser = auth =>
  notBlank(auth.user) &&
  !hasRole(auth.currentOrganization, "ROLE_CREATOR_USER");

// const isCreatorUser = auth =>
//   notBlank(auth.user) && hasRole(auth.currentOrganization, "ROLE_CREATOR_USER");

const isCreatorManagerOrUser = auth =>
  notBlank(auth.user) &&
  hasAnyRole(auth.currentOrganization, nonAdminCreatorRoles);

const AuthorizedRoute = withAuthorization(Route);

const ManagerPanelHome = () => {
  const reduxDispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const { path } = useRouteMatch();
  const history = useHistory();

  useEffect(() => {
    // TODO: use this when allowing non ROLE_ADMIN access to main dashboard
    // if (!hasAdminRole(auth.user) && notManager(auth)) {
    //   console.log("Current Organization...");
    //   console.log(auth.currentOrganization);

    //   const managerOrg = find(
    //     org =>
    //       hasAnyRole(org, ["ROLE_CREATOR_MANAGER", "ROLE_CONTENT_MANAGER"]),
    //     auth.user.organizations,
    //   );

    //   if (notBlank(managerOrg)) {
    //     reduxDispatch(
    //       setCurrentOrganization({
    //         organization: managerOrg,
    //         userId: auth.user.id,
    //       }),
    //     );
    //   } else if (notCreatorUser(auth)) {
    //     const creatorOrg = find(
    //       org => hasRole(org, "ROLE_CREATOR_USER"),
    //       auth.user.organizations,
    //     );
    //     if (notBlank(creatorOrg)) {
    //       reduxDispatch(
    //         setCurrentOrganization({
    //           organization: creatorOrg,
    //           userId: auth.user.id,
    //         }),
    //       );
    //       history.push("/creator");
    //     }
    //   } else if (isCreatorUser(auth)) {
    //     history.push("/creator");
    //   }
    // }

    // For now, redirect all non-ROLE_ADMIN to /creator/home
    if (!hasAdminRole(auth.user) && isCreatorManagerOrUser(auth)) {
      if (notManager(auth)) {
        console.log("Current Organization...");
        console.log(auth.currentOrganization);

        const managerOrg = find(
          org =>
            hasAnyRole(org, ["ROLE_CREATOR_MANAGER", "ROLE_CONTENT_MANAGER"]),
          auth.user.organizations,
        );

        if (notBlank(managerOrg)) {
          reduxDispatch(
            setCurrentOrganization({
              organization: managerOrg,
              userId: auth.user.id,
            }),
          );
        } else if (notCreatorUser(auth)) {
          const creatorOrg = find(
            org => hasRole(org, "ROLE_CREATOR_USER"),
            auth.user.organizations,
          );
          if (notBlank(creatorOrg)) {
            reduxDispatch(
              setCurrentOrganization({
                organization: creatorOrg,
                userId: auth.user.id,
              }),
            );
          }
        }
      }

      // We are currently redirecting all managers to Creator dashboard
      // We will need to update ManagerHomeDashboard if we decide to not redirect
      history.push("/creator");
    }
  }, [auth, auth.user, auth.currentOrganization, reduxDispatch, history]);

  return (
    <Container id="user-admin-application" maxWidth={false} disableGutters>
      <ApplicationHeader />

      <AuthorizedRoute
        exact
        path={`${path}`}
        // roles={["ROLE_ADMIN", "ROLE_CREATOR_MANAGER"]}
        // roles={["ROLE_ADMIN"]}
        roles={creatorRoles}
      >
        <ApplicationPanel id="admin-dashboard">
          <HomeDashboardView />
        </ApplicationPanel>
      </AuthorizedRoute>
    </Container>
  );
};

export default ManagerPanelHome;
